import React, { createContext, useContext } from 'react';
import toast, { Toaster } from 'react-hot-toast';

interface ToastContextType {
    showError: (message: string) => void;
    showSuccess: (message: string) => void;
    showWarning: (message: string) => void;
}

const ToastContext = createContext<ToastContextType | undefined>(undefined);

export const useToast = () => {
    const context = useContext(ToastContext);
    if (!context) {
        throw new Error('useToast must be used within ToastProvider');
    }
    return context;
};

export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const showError = (message: string) => {
        toast.error(message, { duration: 5000, position: 'top-right' });
    };

    const showSuccess = (message: string) => {
        toast.success(message, { duration: 3000, position: 'top-right' });
    };

    const showWarning = (message: string) => {
        toast(message, { icon: '⚠️', duration: 4000, position: 'top-right' });
    };

    return (
        <ToastContext.Provider value={{ showError, showSuccess, showWarning }}>
            {children}
            <Toaster />
        </ToastContext.Provider>
    );
};
